const Snippets = {
    tags: function(measurementId: string) {

        const script = `
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());

            gtag('config', '${measurementId}');
        `;

        return {
            script,
        };
    }
};

export default Snippets;
